import React, { useEffect, useState } from "react";
import { Button, FormGroup, Modal, FormSelect, Row, Col, Spinner } from "react-bootstrap";
import { defineMessages, injectIntl } from "react-intl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from "react-router-dom";

// Services
import AlertDialog from "./AlertDialog";
import { far } from "@fortawesome/pro-regular-svg-icons";
import PropTypes from "prop-types";
import useLocalizedLink from "../hooks/useLocalizedLink";
import useFeedback from "../hooks/useFeedback";

const messages = defineMessages({
    modalTitle: {
        id: "Kuinka todennäköisesti suosittelisit MyRopon käyttöä?",
        defaultMessage: "Kuinka todennäköisesti suosittelisit MyRopon käyttöä?"
    },
    textareaPlaceholder: {
        id: "Otamme mielellämme vastaan avointa palautetta ja kehitysehdotuksia",
        defaultMessage: "Otamme mielellämme vastaan avointa palautetta ja kehitysehdotuksia"
    },
    successLogout: {
        id: "Olet kirjautunut ulos",
        defaultMessage: "Olet kirjautunut ulos"
    },
    actionSend: {
        id: "Kirjaudu ulos",
        defaultMessage: "Kirjaudu ulos"
    },
    actionCancel: {
        id: "Peruuta",
        defaultMessage: "Peruuta"
    },
    feedbackexcepttion: {
        id: "Palauteen lähettäminen ei onnistunut",
        defaultMessage: "Palauteen lähettäminen ei onnistunut"
    },
    successfeedback: {
        id: "Kiitos palautteesta",
        defaultMessage: "Kiitos palautteesta"
    },
    feedbackInfoParagraph1: {
        id: "Valitettavasti emme voi vastata tämän palautelomakkeen kautta jätettyihin yhteydenottopyyntöihin.",
        defaultMessage: "Valitettavasti emme voi vastata tämän palautelomakkeen kautta jätettyihin yhteydenottopyyntöihin."
    },
    feedbackInfoParagraph2: {
        id: "Otathan tarvittaessa yhteyttä suoraan asiakaspalveluumme.",
        defaultMessage: "Otathan tarvittaessa yhteyttä suoraan asiakaspalveluumme."
    },
    customerSurveyParagraph1: {
        id: "Osallistu Ropon asiakastutkimukseen.",
        defaultMessage: "Osallistu Ropon asiakastutkimukseen."
    },
    customerSurveyParagraph2: {
        id: "Arvomme vastaajien kesken lahjakortteja.",
        defaultMessage: "Arvomme vastaajien kesken lahjakortteja."
    },
    logoutMessage: {
        id: "Haluatko varmasti kirjautua ulos?",
        defaultMessage: "Haluatko varmasti kirjautua ulos?"
    },
    errorChooseSubject: {
        id: "Ole hyvä ja valitse aihe.",
        defaultMessage: "Ole hyvä ja valitse aihe."
    },
    errorFillTextbox: {
        id: "Ole hyvä ja täytä tekstikenttä.",
        defaultMessage: "Ole hyvä ja täytä tekstikenttä."
    },
    actionSendAndLogout: {
        id: "Lähetä ja kirjaudu ulos",
        defaultMessage: "Lähetä ja kirjaudu ulos"
    },
    scaleExplanation: {
        id: "(0 = erittäin epätodennäköisesti – 10 = erittäin todennäköisesti)",
        defaultMessage: "(0 = erittäin epätodennäköisesti – 10 = erittäin todennäköisesti)"
    },
    dropdownHeader: {
        id: "Kehitysehdotukset ja palaute",
        defaultMessage: "Kehitysehdotukset ja palaute"
    },
    chooseSubject: {
        id: "Valitse aihe",
        defaultMessage: "Valitse aihe"
    },
    login: {
        id: "Kirjautuminen",
        defaultMessage: "Kirjautuminen"
    },
    developmentProposal: {
        id: "Kehitysehdotus",
        defaultMessage: "Kehitysehdotus"
    },
    payment: {
        id: "Maksaminen",
        defaultMessage: "Maksaminen"
    },
    paymentPlan: {
        id: "Maksuaika",
        defaultMessage: "Maksuaika"
    },
    refund: {
        id: "Maksun palautus",
        defaultMessage: "Maksun palautus"
    },
    useOfService: {
        id: "Palvelun käyttö",
        defaultMessage: "Palvelun käyttö"
    },
    RopoCapitalInGeneral: {
        id: "Ropo yleisesti",
        defaultMessage: "Ropo yleisesti"
    },
    other: {
        id: "Muu",
        defaultMessage: "Muu"
    },
    goBack: {
        id: "Palaa takaisin",
        defaultMessage: "Palaa takaisin"
    }
});

export { messages };

const FeedbackDialog = (props) => {
    const navigate = useNavigate();
    const [messageInput, setMessageInput] = useState('');

    const { getLocalizedLink } = useLocalizedLink();

    const lng = props.intl.formatMessage;
	const customerServiceLink = getLocalizedLink('LINK_CUSTOMER_SERVICE');

    const [NPSScore, setNPSScore] = useState(null);
    const [feedbackTopic, setFeedbackTopic] = useState('');
    const [scoreFilled, setScoreFilled] = useState(false);
    const [topicFilled, setTopicFilled] = useState(false);
    const [textAreaFilled, setTextAreaFilled] = useState(false);
    const [changeButtonText, setChangeButtonText] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [showAlertMessage, setShowAlertMessage] = useState('');
    const [showAlertType, setShowAlertType] = useState(undefined);
    const { sendFeedback } = useFeedback();
    const [sending, setSending] = useState(false);

    //  NPS survey's numeric scale 0-10
    const surveyScoreScale = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    let showCustomerSurvey = false;

    // Customer survey link
    if (process.env.REACT_APP_CUSTOMER_SURVEY_URL && process.env.REACT_APP_CUSTOMER_SURVEY_URL !== '') {
        showCustomerSurvey = true;
    }

    const dropdownOptions = [
        { value: '', topic: lng(messages.chooseSubject) },
        { value: 'Development proposal', topic: lng(messages.developmentProposal) },
        { value: 'Login', topic: lng(messages.login) },
        { value: 'Payment', topic: lng(messages.payment) },
        { value: 'Payment plan', topic: lng(messages.paymentPlan) },
        { value: 'Refund', topic: lng(messages.refund) },
        { value: 'Use of service', topic: lng(messages.useOfService) },
        { value: 'Ropo Capital in general', topic: lng(messages.RopoCapitalInGeneral) },
        { value: 'Other', topic: lng(messages.other) },
    ];

    useEffect(() =>{
        // toggle logout button text if there are changes in the input values
        setChangeButtonText(scoreFilled || topicFilled || textAreaFilled);
    }, [scoreFilled, topicFilled, textAreaFilled]);

    // handle changes in the NPS score
    const handleUpdateScore = (event) => {
        // all numeric scale buttons
        const NPSScoreButtonsList = document.querySelectorAll('.feedback-btn-circle');
        // toggle logout button text
        setScoreFilled(true);

        // check whether or not the button should have class 'selected-score'
        if (event.target.value === NPSScore) {
            // if same number is clicked, set NPS score back to original value and remove class
            setNPSScore(null);
            event.target.classList.remove('selected-score');
            // toggle logout button text
            setScoreFilled(false);
        }
        else {
            // go through buttons and remove selected class
            NPSScoreButtonsList.forEach(item => {
                if (item.classList.contains('selected-score')) {
                    item.classList.remove('selected-score');
                }
            });

            // add class to selected score
            event.target.classList.add('selected-score');
            // set new score
            setNPSScore(event.target.value);
        }
    }

    // handle changes in the dropdown
    const handleSelectChange = (event) => {
        setTopicFilled(event.target.value !== '');
        setShowAlert(false);
        setFeedbackTopic(event.target.value);
    }

    // handle changes in the open feedback textarea
    const handleInputChange = (event) => {
        setTextAreaFilled(event.target.value.length > 0);
        setShowAlert(false);
        setMessageInput(event.target.value);
    }

    const hideDialog = () => {
        props.handleConfirmDialog();
        setFeedbackTopic('');
        setMessageInput('');
        setChangeButtonText(false);
    }

    /**
     * Handle alertDialog. Function takes message and type as parameters
     * and show the alertdialog above all the details related to the invoice.
     *
     * @param {string} message
     * @param {string} type
     */
    const handleAlertDialog = (message, type) => {
        setShowAlertMessage(message);
        setShowAlertType(type);
        setShowAlert(true);
    };
    
    // handle submitting the form
    const handleSubmitFeedback = (event) => {
        event.preventDefault();
        // remove all errors
        setShowAlert(false);
        
        // check if mandatory combinations (topic + open feedback) are missing
        if (feedbackTopic !== '' && messageInput.length === 0) {
            // if feedback topic has been chosen but no open feedback is left, show error
            handleAlertDialog(lng(messages.errorFillTextbox), "danger");
        } else if (feedbackTopic === '' && messageInput.length > 0) {
            // if open feedback is left but no topic is chosen, show error
            handleAlertDialog(lng(messages.errorChooseSubject), "danger");
        } else {
            void confirmLogout();
        }
    }

    const confirmLogout = async () => {
        let alert = null;
        try {
            setSending(true);
            const outcome = await sendFeedback(NPSScore, feedbackTopic, messageInput);
            if (outcome !== null) {
                alert = {message: lng(messages.successfeedback), type: 'primary'};
            }
        } catch (error) {
            console.error(error)
            alert = { message: lng(messages.feedbackexcepttion), type: 'danger' };
        } finally {
            setSending(false);
        }
        hideDialog();
        navigate("/logout", { state: { alert }});
    }

    return (
        <Modal
            name="feedback-dialog"
            show={ props.show }
            onHide={ hideDialog }
            dialogClassName={ "dialog-feedback" }
            style={ {zIndex: 10001 } }
            aria-modal="true"
            aria-labelledby="feedback-dialog-modal-title"
        >
            <Modal.Header closeButton>
                <Button
                    className="modal-back"
                    onClick={ hideDialog }
                    aria-label={ lng(messages.goBack) }
                >
                    <FontAwesomeIcon icon={ far.faArrowLeft } aria-hidden="true" /> { lng(messages.goBack) }
                </Button>
                <Modal.Title>
                    { lng(messages.modalTitle) }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form
                    className="form"
                    id="exit-survey-form"
                    onSubmit={ handleSubmitFeedback }
                    aria-describedby="feedback-info"
                >
                    <div className="text-center">
                        <div id="exit-survey-nps-scale" className="form-group nps-button-group mb-3">
                            { surveyScoreScale.map((option) => {
                                return (
                                    <button type="button" className="feedback-btn-circle" onClick={ (e) => handleUpdateScore(e) } value={ option } key={ option } aria-label={option}>{ option } </button>
                                )
                            }) }
                            <label htmlFor="exit-survey-nps-scale">{ lng(messages.scaleExplanation) }</label>
                        </div>
                        <label className="h4" htmlFor="exit-survey-feedback-topic">{ lng(messages.dropdownHeader) }</label>
                    </div>
                    { showAlert &&
                        <AlertDialog
                            message={ showAlertMessage }
                            type={ showAlertType }
                        />
                    }
                    <FormGroup controlId="exit-survey-feedback-topic" className="form-floating">
                        <FormSelect id="exit-survey-feedback-topic" className="form-control mb-3" value={ feedbackTopic } onChange={ (e) => handleSelectChange(e) } aria-label={ lng(messages.chooseSubject) }>
                            {dropdownOptions.map((option) => (
                                <option value={ option.value } key={ option.value }>{ option.topic }</option>
                            ))}
                        </FormSelect>
                        <label>{ lng(messages.chooseSubject) }</label>
                    </FormGroup>
                    <span className="invalid-feedback" id="invalid-dropdown-topic" />
                    <FormGroup className="form-floating">
                        <textarea id="exit-survey-feedback-textarea"
                                  name={ 'messageInput' }
                                  className="form-control mb-3 pt-5 pt-md-4"
                                  rows="7"
                                  value={ messageInput }
                                  placeholder={ lng(messages.textareaPlaceholder) }
                                  aria-label={lng(messages.textareaPlaceholder) }
                                  onChange={ (event) => handleInputChange(event) }
                        />
                        <span className="invalid-feedback" id="invalid-open-feedback" />
                        <label className="long-floating-label">{ lng(messages.textareaPlaceholder) }</label>
                    </FormGroup>
                </form>
                <AlertDialog
                    message={ <div>{ lng(messages.feedbackInfoParagraph1) } <a title={ customerServiceLink } rel="noopener noreferrer" href={ customerServiceLink } target="_blank">{ lng(messages.feedbackInfoParagraph2) } </a></div> }
                    type="primary"
                />
                { showCustomerSurvey && (
                    <FormGroup id="error" className="form-group customer-survey" onClick={ () => window.open(process.env.REACT_APP_CUSTOMER_SURVEY_URL, "_blank") }>
                        <Row>
                            <Col xs={ 11 }>
                                <h3>{ lng(messages.customerSurveyParagraph1) }</h3>
                                <p>{ lng(messages.customerSurveyParagraph2) }</p>
                            </Col>
                            <Col xs={ 1 }>
                                <div className="survey-pointer"><FontAwesomeIcon icon={ far.faHandPointer } /></div>
                            </Col>
                        </Row>
                    </FormGroup>
                )}
                <Button
                    disabled={sending}
                    variant="primary"
                    type="submit"
                    form="exit-survey-form"
                    aria-label={changeButtonText ? lng(messages.actionSendAndLogout) : lng(messages.actionSend)}
                >
                    {sending && (<Spinner animation="border" size="sm" />)}&nbsp;
                    { changeButtonText ? lng(messages.actionSendAndLogout) : lng(messages.actionSend) }
                </Button>
            </Modal.Body>
        </Modal>
    )
};

FeedbackDialog.propTypes = {
    'intl': PropTypes.object.isRequired,
    'show': PropTypes.bool,
    'handleConfirmDialog': PropTypes.func
};

export default injectIntl(FeedbackDialog);
